import { ArrowHeadDown, ArrowHeadUp } from "@/assets";
import { Button, FilterCommon, HistoryModal, HSkeleton, ImportModal, PageHeader, Table } from "@/components";
import PolicyManagementEmployeeModal from "@/components/PolicyManagement/PolicyManagementEmployeeModal/PolicyManagementEmployeeModal.vue";
import {
  CREATE_TYPE,
  EDIT_TYPE,
  filtersJson,
  getInfoStaffFull,
  handleMessagesAPI,
  HISTORY_TYPE,
  PAGINATION_DEFAULT,
  policyManagementEmployeeHistoryColumns,
  POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
  ROUTER_PAGE_POLICY_MANAGEMENT,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
} from "@/utils";
import { mapState } from "vuex";

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

export default {
  name: "PolicyManagementEmployeeHistory",
  components: {
    FilterCommon,
    Button,
    Table,
    PolicyManagementEmployeeModal,
    ImportModal,
    HistoryModal,
    PageHeader,
    HSkeleton,
  },
  data() {
    return {
      columns: policyManagementEmployeeHistoryColumns,
      POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
      dataFilterDefault: {},
      actions,
      visibleMoreFilter: false,
      ArrowHeadDown,
      ArrowHeadUp,
      filtersJson,
      filterList: filtersJson[POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
      visibleModal: false,
      visibleModalImport: false,
      visibleModalHistory: false,
      type: null,
      recordSelected: null,
      loadingDownload: false,
      filter: { ...PAGINATION_DEFAULT, employeeId: this.$route.params.id },
    };
  },
  watch: {
    filter() {
      this.getPolicyManagementEmployeeHistoryList();
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      policyManagementEmployeeHistoryList: (state) =>
        state.policyManagementEmployee.policyManagementEmployeeHistoryList,
      policyManagementEmployeeHistoryInfo: (state) =>
        state.policyManagementEmployee.policyManagementEmployeeHistoryInfo,
      historyPolicyManagementEmployeeList: (state) =>
        state.policyManagementEmployee.historyPolicyManagementEmployeeList,
      pages: (state) => state.policyManagementEmployee.pages,
      loading: (state) => state.user.loading,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
    fullNameStaff() {
      return getInfoStaffFull(this.policyManagementEmployeeHistoryInfo);
    },
  },
  created() {},
  mounted() {
    this.getPolicyManagementEmployeeHistoryList();
  },
  methods: {
    onBack() {
      this.$router.push({ name: ROUTER_PAGE_POLICY_MANAGEMENT });
    },
    handleFilter(payload) {
      const { applyFromDate, applyToDate, expireFromDate, expireToDate } = payload;
      !applyFromDate && delete this.filter?.applyFromDate;
      !applyToDate && delete this.filter?.applyToDate;
      !expireFromDate && delete this.filter?.expireFromDate;
      !expireToDate && delete this.filter?.expireToDate;
      this.filter = { ...this.filter, ...payload, page: 1 };
    },
    async getPolicyManagementEmployeeHistoryList() {
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("policyManagementEmployee/getPolicyManagementListByEmployee", this.filter);
      } catch (error) {
        // handle error
        handleMessagesAPI(error?.response?.data);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    async onAction({ type, data }) {
      this.type = type;
      this.recordSelected = data;
      switch (type) {
        case HISTORY_TYPE: {
          try {
            await this.$store.dispatch("policyManagementEmployee/getHistoryPolicyManagementEmployee", { id: data?.id });
          } catch (error) {
            handleMessagesAPI(error?.response?.data);
          }
          this.visibleModalHistory = true;
          break;
        }
        case EDIT_TYPE: {
          this.visibleModal = true;
          break;
        }
        default: {
          this.visibleModal = true;
        }
      }
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    handleSetPolicy() {
      this.type = CREATE_TYPE;
      this.visibleModal = true;
    },
    onCancel() {
      this.visibleModal = false;
      this.visibleModalHistory = false;
      this.recordSelected = null;
      this.type = null;
    },
  },
};
